var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipseLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 501,
    viewBox: "0 0 501 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3076 76.3968C172.377 -19.6722 328.135 -19.6722 424.204 76.3968C520.273 172.466 520.273 328.224 424.204 424.293C328.135 520.362 172.377 520.362 76.3076 424.293C-19.7614 328.224 -19.7614 172.466 76.3076 76.3968ZM73.4791 73.5683C171.11 -24.0627 329.401 -24.0627 427.033 73.5683C524.664 171.199 524.664 329.491 427.033 427.122C329.401 524.753 171.11 524.753 73.4792 427.122C-24.1519 329.491 -24.1519 171.199 73.4791 73.5683Z",
    fill: "url(#paint0_linear_2138_648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2138_648",
    x1: 427.033,
    y1: 427.122,
    x2: 73.4791,
    y2: 73.5683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#AB9834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseLoader);
export default __webpack_public_path__ + "static/media/ellipse-loader.430d583ab435796e36c31f16773ccb1d.svg";
export { ForwardRef as ReactComponent };